export default __webpack_public_path__ + "static/moqups-7dfe53b2e24cb412e3f9c42544e22c6e.svg";